import React, { lazy, memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import TitleToolTip from '../TitleToolTip/index';
import Styled from './style';

const layout = window?.$environment?.CURRENT_LAYOUT;
const PercentageBarGraph = lazy(() =>
    import(`globalcomponents/UI/Graph/PercentageBarGraph/${layout}`)
);
const Label = lazy(() => import(`globalcomponents/UI/Label/${layout}`));

const GraphItem = memo(({ title, value, total, percentage, info }) => (
    <Styled.Items>
        <Styled.Title>
            <TitleToolTip title={title} className="title" small={true} info={info} />
            <Label variant="body1" className="title">{`${value}/${total}`}</Label>
        </Styled.Title>
        <PercentageBarGraph  isFlexed percentage={`${percentage}%`} smallSize />
    </Styled.Items>
));

GraphItem.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    total: PropTypes.string.isRequired,
    percentage: PropTypes.number.isRequired,
    info: PropTypes.node,
};

GraphItem.defaultProps = {
    info: 'infoBox',
};

const FleetScore = ({ scoreCard }) => {
    const { t } = useTranslation();

    const translations = useMemo(() => ({
        driverBehavior: t('scorecard.driverBehavior'),
        driverBehaviorDesc: <p><Trans i18nKey="scorecard.driverBehaviorDescription" /></p>,
        poweredDays: t('newScoreCard.poweredDays'),
        poweredDaysDesc: <p><Trans i18nKey="scorecard.unpoweredDaysDescription" /></p>,
        radiusViolations: t('scorecard.radiusViolations'),
        radiusViolationsDesc: <p><Trans i18nKey="scorecard.radiusViolationsDesc" /></p>,
    }), [t]);

    const {
        aggregatedDrivingBehaviorScore,
        aggregatedUnpoweredDaysScore,
        aggregatedRadiusViolationsScore,
    } = scoreCard || {};

    return (
        <Styled.Wrapper>
            <GraphItem
                title={translations.driverBehavior}
                value={aggregatedDrivingBehaviorScore}
                total="60"
                percentage={aggregatedDrivingBehaviorScore * 1.665}
                info={translations.driverBehaviorDesc}
            />
            <GraphItem
                title={translations.poweredDays}
                value={aggregatedUnpoweredDaysScore}
                total="20"
                percentage={aggregatedUnpoweredDaysScore * 5}
                info={translations.poweredDaysDesc}
            />
            <GraphItem
                title={translations.radiusViolations}
                value={aggregatedRadiusViolationsScore}
                total="20"
                percentage={aggregatedRadiusViolationsScore * 5}
                info={translations.radiusViolationsDesc}
            />
        </Styled.Wrapper>
    );
};

FleetScore.propTypes = {
    scoreCard: PropTypes.shape({
        aggregatedDrivingBehaviorScore: PropTypes.number,
        aggregatedUnpoweredDaysScore: PropTypes.number,
        aggregatedRadiusViolationsScore: PropTypes.number,
    }),
};

FleetScore.defaultProps = {
    scoreCard: null,
};

export default FleetScore;